import LassoAttributes from './LassoAttributes';

export default LassoAttributes;
